import { FormBase } from 'core/components';
import _ from 'lodash';

export const insuranceFormProperties = {
    fields: [
        {
            name: 'name',
            label: 'IMPORT_PATIENT.INSURANCE.INSURANCE_LABEL',
            placeholder: 'IMPORT_PATIENT.INSURANCE.INSURANCE_PLACEHOLDER',
            rules: 'required'
        },
        {
            name: 'policyNumber',
            label: 'IMPORT_PATIENT.INSURANCE.POLICY_NUMBER_LABEL',
            placeholder: 'IMPORT_PATIENT.INSURANCE.POLICY_NUMBER_PLACEHOLDER',
            rules: 'string|required'                       
        },
        {
            name: 'groupNumber',
            label: 'IMPORT_PATIENT.INSURANCE.GROUP_NUMBER_LABEL',
            placeholder: 'IMPORT_PATIENT.INSURANCE.GROUP_NUMBER_PLACEHOLDER',
            rules: 'string|required'                       
        }
    ]
};

export function getInsuranceFormPropertiesWithPrefix(prefix) {
    let properties = _.clone(insuranceFormProperties);
    let result = {
        fields: properties.fields.map(item => {                
            return {
                name: prefix + item.name.charAt(0).toUpperCase() + item.name.slice(1),
                label: item.label,
                placeholder: item.placeholder,
                rules: item.rules
            } 
        })
    };
    return result;
}

export default class InsuranceForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return insuranceFormProperties;
    }
}
